export default __webpack_public_path__ + "static/media/offline.94e45b9a.png";